import { PetType } from 'constants/pet-type';
import { SegmentationIds } from 'constants/segmentation';
import { SortOptions } from 'constants/collection';

export default {
  'cdp:general:price_from': 'from',
  'cdp:general:product': 'Product',
  'cdp:general:products': '{amount, plural, =0 {# Products} one {# Product} other {# Products}}',
  'cdp:filter:showproducts': 'Show products',
  'cdp:filter:showproduct': 'Show product',
  'cdp:filter:close': 'Close',
  'cdp:filter:foodtypes': 'Food types',
  'cdp:filter:foodtypes:nassfutter': 'Wet food',
  'cdp:filter:foodtypes:trockenfutter': 'Dry food',
  'cdp:filter:foodtypes:frische-menus': 'BARF menus',
  'cdp:filter:foodtypes:nahrungserganzung': 'Food supplements',
  'cdp:filter:foodtypes:snacks': 'Snacks',
  'cdp:filter:foodtypes:bundles': 'Value packs',

  'cdp:filter:species': 'Animal species',
  'cdp:filter:species:fur-hunde': 'Dogs',
  'cdp:filter:species:fur-katzen': 'Cats',

  'cdp:filter:sizes': 'Animal size',
  'cdp:filter:sizes:klein': 'Small',
  'cdp:filter:sizes:mittel': 'Medium',
  'cdp:filter:sizes:gross': 'Large',

  'cdp:filter:sorts': 'Sorts',
  'cdp:filter:sorts:huhn': 'Chicken',
  'cdp:filter:sorts:rind': 'Beef',
  'cdp:filter:sorts:ente': 'Duck',
  'cdp:filter:sorts:pute': 'Turkey',
  'cdp:filter:sorts:kalb': 'Veal',
  'cdp:filter:sorts:wild': 'Game',
  'cdp:filter:sorts:lachs': 'Salmon',
  'cdp:filter:sorts:pferd': 'Horse',
  'cdp:filter:sorts:lamm': 'Lamb',
  'cdp:filter:sorts:insekten': 'Insects',
  'cdp:filter:sorts:veggi': 'Veggie',
  'cdp:filter:sorts:vegan': 'Vegan',
  'cdp:filter:sorts:ziege': 'Goat',
  'cdp:filter:sorts:thunfisch': 'Tuna',
  'cdp:filter:sorts:forelle': 'Trout',
  'cdp:filter:sorts:kanguru': 'Kangaroo',
  'cdp:filter:sorts:kaninchen': 'Rabbit',
  'cdp:filter:sorts:straus': 'Ostrich',
  'cdp:filter:sorts:wasserbuffel': 'Water buffalo',
  'cdp:filter:sorts:krill': 'Krill',
  'cdp:filter:sorts:sprotten': 'Sprats',
  'cdp:filter:sorts:hirsch': 'Deer',
  'cdp:filter:sorts:geflugel': 'Poultry',
  'cdp:filter:sorts:truthahn': 'Turkey',
  'cdp:filter:sorts:fisch': 'Fish',
  'cdp:filter:sorts:schwein': 'Pork',
  'cdp:filter:sorts:rind-and-kalb': 'Beef & Veal',
  'cdp:filter:sorts:vegetarisch-vegan': 'Vegetarian / vegan',
  'cdp:filter:sorts:bowls-and-similars': 'Bowls, Lick Mats & Drinkers',
  'cdp:filter:sorts:toys': 'Toys',
  'cdp:filter:sorts:walking': 'Walking',
  'cdp:filter:sorts:sleeping': 'Sleeping Places',
  'cdp:filter:sorts:other-accessories': 'Other Accessories',

  // Used in Personalized Cdp
  'cdp:filter:sorts:duck': 'Duck',
  'cdp:filter:sorts:rabbit': 'Rabbit',
  'cdp:filter:sorts:game': 'Game',
  'cdp:filter:sorts:deer': 'Deer',
  'cdp:filter:sorts:poultry': 'Poultry',
  'cdp:filter:sorts:chicken': 'Chicken',
  'cdp:filter:sorts:veal': 'Veal',
  'cdp:filter:sorts:kangaroo': 'Kangaroo',
  'cdp:filter:sorts:salmon': 'Salmon',
  'cdp:filter:sorts:turkey': 'Turkey',
  'cdp:filter:sorts:beef': 'Beef',
  'cdp:filter:sorts:pork': 'Pork',
  'cdp:filter:sorts:tuna': 'Tuna',
  'cdp:filter:sorts:wild-turkey': 'Wild Turkey',
  'cdp:filter:sorts:horse': 'Horse',

  'cdp:filter:desires': 'Special features',
  'cdp:filter:desires:getreidefrei': 'Grain-free',
  'cdp:filter:desires:glutenfrei': 'Gluten-free',
  'cdp:filter:desires:hypoallergen': 'Hypoallergenic',
  'cdp:filter:desires:hypocare': 'Hypo',
  'cdp:filter:desires:leicht-verdaulich': 'Easily digestible',
  'cdp:filter:desires:monoprotein': 'Monoprotein',
  'cdp:filter:desires:zuckerfrei': 'Sugar-free',
  'cdp:filter:desires:kalorienreduziert': 'Calorie-reduced',
  'cdp:filter:desires:low-energy': 'Low Energy',
  'cdp:filter:desires:high-energy': 'High Energy',
  'cdp:filter:desires:spezielle-erkrankungen': 'Special Conditions',

  'cdp:filter:age': 'Age',
  'cdp:filter:age:adult': 'Adult',
  'cdp:filter:age:senior': 'Senior',
  'cdp:filter:age:welpe': 'Puppy',
  'cdp:filter:age:kitten': 'Kitten',
  'cdp:filter:age:junior': 'Junior',
  'cdp:filter:age:adult-1-6-jahre': 'Adult (1-6 years)',
  'cdp:filter:age:senior-7-jahre': 'Senior (8+ years)',

  'cdp:filter:line': 'Line',
  'cdp:filter:line:classic': 'Classic',
  'cdp:filter:line:sensitiv': 'Sensitive',
  'cdp:filter:line:pure-meat': 'Pure Meat',
  'cdp:filter:line:extra-meat': 'Extra Meat',
  'cdp:filter:line:breed-fit': 'Breed Fit',
  'cdp:filter:line:rollen': 'Rolls',
  'cdp:filter:line:denta-snacks': 'Denta Snacks',
  'cdp:filter:line:filet-menu': 'Fillet Menu',
  'cdp:filter:line:silkycream': 'Silky Cream',
  'cdp:filter:line:puremeat': 'Pure Meat',
  'cdp:filter:line:meatypate': 'Meaty Pâté',
  'cdp:filter:line:juicyfilets': 'Juicy Filets',
  'cdp:filter:line:green': 'Green',
  'cdp:filter:line:genieser-filets': 'Gourmet Filets',
  'cdp:filter:line:superfood': 'Superfood',
  'cdp:filter:line:junior': 'Junior',
  'cdp:filter:line:hypocare': 'Hypocare',
  'cdp:filter:line:feinschmecker-pate': 'Gourmet Pate',
  'cdp:filter:line:kaltgepresst': 'Cold Pressed',
  'cdp:filter:line:mini': 'Mini',
  'cdp:filter:line:limited': 'Limited',
  'cdp:filter:line:softies': 'Softies',
  'cdp:filter:line:happchen': 'Bites',
  'cdp:filter:line:pasteten': 'Pâtés',
  'cdp:filter:line:kausnacks': 'Chew Snacks ',
  'cdp:filter:line:saucen-menu': 'Sauce Menu',
  'cdp:filter:line:akzeptanz': 'Acceptance',
  'cdp:filter:line:creme-snack': 'Cream Snack',
  'cdp:filter:line:soft-snacks': 'Soft Snacks ',
  'cdp:filter:line:filet-snack': 'Fillet Snack ',
  'cdp:filter:line:suppe': 'Soup',
  'cdp:filter:line:vet': 'VET',
  'cdp:filter:line:mousse': 'Mousse',
  'cdp:filter:line:tasties': 'Tasties',
  'cdp:filter:line:soft': 'Soft',
  'cdp:filter:line:cookies': 'Cookies',
  'cdp:filter:line:bundle': 'Trial Packs',
  'cdp:filter:line:knochen-and-kaurollen': 'Bones & Chew Rolls',
  'cdp:filter:line:trainingssnacks': 'Training Snacks',
  'cdp:filter:line:zahnpflege': 'Dental Care',
  'cdp:filter:line:pasten-and-cremesnacks': 'Pastes & Cream Snacks',
  'cdp:filter:line:hundekekse': 'Dog Cookies',
  'cdp:filter:line:kaustreifen-and-sticks': 'Chew Strips & Sticks',
  'cdp:filter:line:toppers': 'Toppers',
  'cdp:filter:line:gefriergetrocknet': 'Freeze-dried',

  'cdp:filter:funktion': 'Function',
  'cdp:filter:funktion:gelenk': 'Joint',
  'cdp:filter:funktion:haut-and-fell': 'Skin & Coat',
  'cdp:filter:funktion:zeckensaison': 'Tick Season',
  'cdp:filter:funktion:denta': 'Denta',
  'cdp:filter:funktion:entspannung': 'Relaxation',
  'cdp:filter:funktion:leber': 'Liver',
  'cdp:filter:funktion:verdauung': 'Digestion',
  'cdp:filter:funktion:erkaltung': 'Cold',
  'cdp:filter:funktion:digestion': 'Digestion & gulping',
  'cdp:filter:funktion:busy': 'Activity',
  'cdp:filter:funktion:smart-accessories': 'Intelligence Accessories',

  'cdp:filter:sort-menu:label:default': 'By relevance',
  'cdp:filter:sort-menu:label:price-ascending': 'Price, ascending',
  'cdp:filter:sort-menu:label:price-descending': 'Price, descending',
  'cdp:filter:sort-menu:label:new': 'New arrivals',
  'cdp:filter:sort-menu:label:best-selling': 'Bestsellers',
  'cdp:filter:sort-menu:label:title': 'Item name',
  'cdp:filter:sort-menu:aria-label-select': 'Sort products',

  'cdp:filter:nutritional-needs': 'Need',
  'cdp:filter:nutritional-needs:sehr-wahlerisch': 'Very picky',
  'cdp:filter:nutritional-needs:pickyeatercat': 'Very picky',
  'cdp:filter:nutritional-needs:digestioncat': 'Digestive problems',
  'cdp:filter:nutritional-needs:verdauungsprobleme': 'Digestive problems',
  'cdp:filter:nutritional-needs:unvertraglichkeiten-allergien': 'Intolerances / Allergies',
  'cdp:filter:nutritional-needs:haut-and-fellprobleme': 'Skin & coat problems ',
  'cdp:filter:nutritional-needs:ubergewicht': 'Overweight',
  'cdp:filter:nutritional-needs:overweightcat': 'Overweight',
  'cdp:filter:nutritional-needs:intolerancecat': 'Allergies / Intolerances',
  'cdp:filter:nutritional-needs:hairballcat': 'Hairball help',
  'cdp:filter:nutritional-needs:skinfurcat': 'Skin & fur problems',
  'cdp:filter:nutritional-needs:immunitycat': 'Immunity+',

  'cdp:filter:health-needs': 'Health need',
  'cdp:filter:health-needs:gelenk': 'Joint',
  'cdp:filter:health-needs:ungeziefer': 'Pest and tick protection',
  'cdp:filter:health-needs:haut-and-fell': 'Skin & Coat',
  'cdp:filter:health-needs:zeckensaison': 'Tick Season',
  'cdp:filter:health-needs:denta': 'Denta',
  'cdp:filter:health-needs:entspannung': 'Relaxation',
  'cdp:filter:health-needs:leber': 'Liver',
  'cdp:filter:health-needs:verdauung': 'Digestion',
  'cdp:filter:health-needs:erkaltung': 'Cold',

  'cdp:filter:feed-type': 'Feed type',
  'cdp:filter:feed-type:nassfutter': 'Wet food',
  'cdp:filter:feed-type:trockenfutter': 'Dry food',
  'cdp:filter:feed-type:barf': 'BARF',
  'cdp:filter:feed-type:snacks': 'Snacks',

  'cdp:filter:snack-type': 'Snack type',
  'cdp:filter:snack-type:knochen-and-kaurollen': 'Bones & Chew Rolls',
  'cdp:filter:snack-type:trainingssnacks': 'Training Snacks',
  'cdp:filter:snack-type:zahnpflege': 'Dental Care',
  'cdp:filter:snack-type:pasten-and-cremesnacks': 'Pastes & Cream Snacks',
  'cdp:filter:snack-type:hundekekse': 'Dog Cookies',
  'cdp:filter:snack-type:kaustreifen-and-sticks': 'Chew Strips & Sticks',
  'cdp:filter:snack-type:creme-snack': 'Cream Snacks',
  'cdp:filter:snack-type:filet-snack': 'Fillet Snack',
  'cdp:filter:snack-type:suppe': 'Soups ',
  'cdp:filter:snack-type:soft-snacks': 'Soft Snacks',
  'cdp:filter:snack-type:sensitiv': 'Sensitive Snacks',
  'cdp:filter:snack-type:pasten': 'Pastes',
  'cdp:filter:snack-type:toppers': 'Toppers',
  'cdp:filter:snack-type:functional-snacks': 'Functional Snacks',
  'cdp:filter:snack-type:knuspersnacks': 'Crunchy Snacks',
  'cdp:filter:snack-type:zahnpflege-and-kausnacks': 'Dental Care & Chew Snacks',
  'cdp:filter:snack-type:pasten-and-softsnacks': 'Pastes & Soft Snacks',

  'cdp:allergy-filter:header': 'My dog cannot tolerate...',
  'cdp:allergy-filter:without': 'Without',
  'cdp:allergy-filter:rind': 'Beef',
  'cdp:allergy-filter:getreidefrei': 'Grain',
  'cdp:allergy-filter:huhn': 'Chicken',
  'cdp:allergy-filter:pute': 'Turkey',
  'cdp:allergy-filter:ente': 'Duck',
  'cdp:allergy-filter:fisch': 'Fish',
  'cdp:allergy-filter:kartoffel': 'Potato',
  'cdp:allergy-filter:lamm': 'Lamb',
  'cdp:allergy-filter:pferd': 'Horse',
  'cdp:allergy-filter:ziege': 'Goat',
  'cdp:allergy-filter:suskartoffel': 'Sweet potato',

  'cdp:productcard:back-soon': 'Out of stock',

  'cdp:filter:label': 'Filter',
  'cdp:noproductsfound': 'No products found.',
  'cdp:similarproducts': 'More products',
  'cdp:resetfilters': 'Reset filters',
  'cdp:reset': 'Reset',
  'cdp:toproductbutton': 'To the product',
  'cdp:showmoreproducts': 'Show all products',

  'cdp:configureproduct': 'Add to cart',
  'cdp:sizes': 'Size',
  'cdp:packages': 'Unit',

  'cdp:addtocart': 'Add to cart',
  'cdp:buy-panel:preorder': 'Pre-order now',
  'cdp:intervals': 'Interval',

  'cdp:availableas': 'Available in',
  'cdp:petsdelifordogs': 'Pets Deli for dogs',
  'cdp:petsdeliforcats': 'Pets Deli for cats',
  'cdp:singlepurchase': 'Single purchase',
  'cdp:regulardelivery': 'Regular delivery',
  'cdp:notavailable': 'Currently not available',

  'cdp:subscription-intervals:2-weeks': 'Every 2 weeks',
  'cdp:subscription-intervals:4-weeks': 'Every 4 weeks',
  'cdp:subscription-intervals:6-weeks': 'Every 6 weeks',
  'cdp:subscription-intervals:8-weeks': 'Every 8 weeks',

  'cdp:findoutmore': 'Discover now',

  // Following translations has beend added for an A/B test
  // see https://petsdeli.atlassian.net/browse/PT-3690
  'cdp:filter:special-desires': 'Special needs',
  'cdp:filter:taste': 'Taste',
  'cdp:filter:special-desires:fur-welpen': 'For puppies & young dogs',
  'cdp:filter:special-desires:fur-senioren': 'For seniors',
  'cdp:filter:special-desires:getreide-glutenfrei': 'Grain- & gluten-free recipe',
  'cdp:filter:special-desires:ohne-kartoffeln': 'Without potatoes',
  'cdp:filter:special-desires:fur-allergiker': 'For allergy sufferers',
  'cdp:filter:special-desires:sensible-verdauung': 'Sensitive digestion',
  'cdp:filter:special-desires:weniger-kalorien': 'Fewer calories',
  'cdp:filter:special-desires:fur-aktive-hunde': 'For active dogs',
  'cdp:filter:special-desires:fur-kleine-rassen': 'For small breeds',
  'cdp:filter:special-desires:spezielle-erkrankungen': 'Special diseases',

  'cdp:filter:taste:geflugel': 'Poultry',
  'cdp:filter:taste:rind-kalb': 'Beef & Veal',
  'cdp:filter:taste:wild': 'Game',
  'cdp:filter:taste:fisch': 'Fish',
  'cdp:filter:taste:lamm': 'Lamb',
  'cdp:filter:taste:pferd': 'Horse',
  'cdp:filter:taste:ziege': 'Goat',
  'cdp:filter:taste:kanguru': 'Kangaroo',
  'cdp:filter:taste:insekten': 'Insects',
  'cdp:filter:taste:vegetarisch-vegan': 'Vegetarian / Vegan',
  [`cdp:filter:sort:${SortOptions.relevance}`]: 'Popularity',
  [`cdp:filter:sort:${SortOptions.rating}`]: 'Rating',
  [`cdp:filter:sort:${SortOptions['price-asc']}`]: 'Lowest price',
  [`cdp:filter:sort:${SortOptions['price-desc']}`]: 'Highest price',
  [`cdp:filter:sort:${SortOptions.acceptance}`]: 'Best acceptance',
  [`cdp:filter:sort:${SortOptions.placeholder}`]: 'Sort',

  'cdp:nutrition-needs-guidance:description':
    'Individual <strong>needs</strong>. Individual <strong>formulations</strong>. We find the perfect food for your dog!',
  'cdp:nutrition-needs-guidance:dropwdown:bundle': "Choose your dog's needs",
  'cdp:nutrition-needs-guidance:dropwdown:pickyeater': 'My dog is very picky',
  'cdp:nutrition-needs-guidance:dropwdown:intolerance': 'My dog has intolerances',
  'cdp:nutrition-needs-guidance:dropwdown:digestion': 'My dog has digestive problems',
  'cdp:nutrition-needs-guidance:dropwdown:welpe': 'My dog is a puppy',
  'cdp:nutrition-needs-guidance:dropwdown:foodaid': 'I want advice',
  'cdp:nutrition-needs-guidance:dropwdown:no-help-needed': "I don't need help",

  'cdp:toast:add-single-item': 'Good choice! Your trial pack has been added to the cart.',

  'cdp:standalone-cdp:headline': 'Discover our variety',
  'cdp:standalone-cdp:subheadline': 'Individual needs. Individual formulations.',
  'cdp:standalone-cdp:subheadline:segment': 'More choice',
  'cdp:standalone-cdp:load-more': 'Load more products',
  [`cdp:standalone-cdp:headline:${SegmentationIds.DogAdult}`]: 'For adult dogs ',
  'cdp:standalone-cdp:headline:intolerance': 'For dogs with intolerances',
  'cdp:standalone-cdp:headline:pickyeater': 'For picky dogs',
  'cdp:standalone-cdp:headline:digestion': 'For dogs with digestive problems',
  'cdp:standalone-cdp:headline:skin-fur': 'For dogs with skin & coat problems',
  'cdp:standalone-cdp:headline:overweight': 'For overweight dogs',
  'cdp:standalone-cdp:headline:prevention': 'For dogs you want to keep healthy long-term',
  'cdp:standalone-cdp:headline:welpe': 'For puppies',
  'cdp:standalone-cdp:headline:senior': 'For seniors',
  'cdp:standalone-cdp:headline:spitz': 'For Spitz',
  'cdp:standalone-cdp:headline:chihuahua': 'For Chihuahuas',
  'cdp:standalone-cdp:headline:shepherd-dog': 'For Shepherd Dogs',
  'cdp:standalone-cdp:headline:bulldog': 'For Bulldogs',
  'cdp:standalone-cdp:headline:terrier': 'For Terriers',
  'cdp:standalone-cdp:headline:poodle': 'For Poodles',
  'cdp:standalone-cdp:headline:havanese': 'For Havanese & Maltese',
  'cdp:standalone-cdp:headline:dachshund': 'For Dachshunds',
  'cdp:standalone-cdp:headline:herdingdog': 'For Herding Dogs',
  'cdp:standalone-cdp:headline:retriever': 'For Retrievers',
  [`cdp:standalone-cdp:headline:${SegmentationIds.MixedLarge}`]: 'For large mixed breeds',
  [`cdp:standalone-cdp:headline:${SegmentationIds.MixedSmall}`]: 'For small mixed breeds',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatPickyEater}`]: 'For picky cats',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatDigestion}`]:
    'For cats with digestive problems',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatOverweight}`]: 'For overweight cats',
  [`cdp:standalone-cdp:headline:${SegmentationIds.Kitten}`]: 'For kittens',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatSenior}`]: 'For seniors',
  [`cdp:standalone-cdp:headline:${SegmentationIds.IntoleranceCat}`]: 'For cats with intolerances',
  [`cdp:standalone-cdp:headline:${SegmentationIds.SkinFurCat}`]:
    'For cats with skin & fur problems',
  [`cdp:standalone-cdp:headline:${SegmentationIds.CatAdult}`]: 'For adult cats',
  [`cdp:standalone-cdp:headline:${SegmentationIds.HairballHelp}`]:
    'For cats with hairball problems',
  'cdp:standalone-cdp:headline:withPetName': 'More selection for {petName}',

  'cdp:tile:badge:save': 'Save {amount}%',

  'cdp:pet-profile:selector:pet-profile-available:title-general-cdp:dog':
    "Adapt selection to my dog's needs?",
  'cdp:pet-profile:selector:pet-profile-available:title-general-cdp:cat':
    "Adapt selection to my cat's needs?",
  'cdp:pet-profile:selector:pet-profile-available:title-with-name':
    "Adapt selection to {petName}'s needs?",

  // Personalization gateway CTA. The pet type is part of the key, the remaining
  // variables are name (pet name) and need (label of the need the CDP represents).
  [`cdp:pet-profile:gateway:${PetType.Dog}:navigate:title`]:
    'Want to see recommendations for your dog?',
  [`cdp:pet-profile:gateway:${PetType.Cat}:navigate:title`]:
    'Want to see recommendations for your cat?',
  'cdp:pet-profile:gateway:navigate:title-with-name': 'Want to see recommendations for {name}?',
  [`cdp:pet-profile:gateway:${PetType.Dog}:navigate:text`]:
    "We've put together food and products tailored to your dog, making it easier to find the right options.",
  [`cdp:pet-profile:gateway:${PetType.Cat}:navigate:text`]:
    "We've put together food and products tailored to your cat, making it easier to find the right options.",
  'cdp:pet-profile:gateway:navigate:text-with-name':
    "We've put together food and products tailored to {name}, making it easier to find the right options.",
  'cdp:pet-profile:gateway:navigate:cta': 'See recommendations',

  'cdp:pet-profile:gateway:login:cta': 'Log in',

  [`cdp:pet-profile:gateway:${PetType.Dog}:update:title`]: '{need} – relevant to your dog too?',
  [`cdp:pet-profile:gateway:${PetType.Cat}:update:title`]: '{need} – relevant to your cat too?',
  'cdp:pet-profile:gateway:update:title-with-name': '{need} – relevant to {name} too?',
  'cdp:pet-profile:gateway:update:text':
    "We'll update the profile so you get even more relevant recommendations.",
  'cdp:pet-profile:gateway:update:cta': 'Update profile',

  [`cdp:pet-profile:gateway:${PetType.Dog}:create-another:title`]: 'Got another dog?',
  [`cdp:pet-profile:gateway:${PetType.Cat}:create-another:title`]: 'Got another cat?',
  [`cdp:pet-profile:gateway:${PetType.Dog}:create-another:text`]:
    'Create another profile to get personalised recommendations for each of your dogs.',
  [`cdp:pet-profile:gateway:${PetType.Cat}:create-another:text`]:
    'Create another profile to get personalised recommendations for each of your cats.',
  'cdp:pet-profile:gateway:create-another:cta': 'Create a new profile',

  [`cdp:pet-profile:gateway:${PetType.Dog}:create:title`]:
    'Get personalised recommendations for your dog',
  [`cdp:pet-profile:gateway:${PetType.Cat}:create:title`]:
    'Get personalised recommendations for your cat',
  [`cdp:pet-profile:gateway:${PetType.Dog}:create:text`]:
    'Create a profile so we can recommend food and products tailored to your dog.',
  [`cdp:pet-profile:gateway:${PetType.Cat}:create:text`]:
    'Create a profile so we can recommend food and products tailored to your cat.',
  'cdp:pet-profile:gateway:create:cta': 'Create a profile',

  'cdp:product-card:variant-button:single': 'Show 1 variant',
  'cdp:product-card:variant-button:multiple': 'Show {amount} variants',
  'cdp:product-card:variant-modal:title': 'Choose product variant',
  'cdp:product-card:variant-modal:discount-info': '{couponCode} has been successfully added',
  'cdp:product-card:variant-modal:product-not-available':
    'The product is unavailable indefinitely.',

  'cdp:ab-test:product-card:additional-price-info': 'incl. {percentage}% subscription discount',
  'cdp:ab-test:product-card:additional-price-info:coupon': ' {couponCode} coupon',
  'cdp:ab-test:product-card:in-cart': 'In cart',
};
